import type { UserConsent } from '@/shared/data-types';

/**
 * 필수 약관 중 미동의 항목이 있는지 — 약관 동의 온보딩(`/auth/consent`) 진입 판정 SSOT.
 *
 * 선택 항목(마케팅 수신 등)은 미동의여도 통과 — 게이트는 **필수만** 본다. 호출처는 현재 `pages/consent`
 * (이미 동의 완료면 화면을 그리지 않고 pass-through) 이고, 라우트 가드(`requireConsent`) 도입 시 함께 쓴다.
 */
export function hasUnagreedRequired(consents: UserConsent[]): boolean {
  return consents.some((consent) => consent.required && !consent.agreed);
}
